module.exports = __webpack_public_path__ + "media/images/lb/435-cbc8d51937f5f0ba558247417217066f.svg";